module.exports = __webpack_public_path__ + "static/media/jegs_home-page_full.a22667da.jpg";